import { render, staticRenderFns } from "./ModalAdminCustomerService.vue?vue&type=template&id=5720a1a7&scoped=true&lang=pug&"
import script from "./ModalAdminCustomerService.vue?vue&type=script&lang=ts&"
export * from "./ModalAdminCustomerService.vue?vue&type=script&lang=ts&"
import style0 from "./ModalAdminCustomerService.vue?vue&type=style&index=0&id=5720a1a7&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5720a1a7",
  null
  
)

export default component.exports